import React from 'react';
import '../styles/TierCard.css';

const TierCard = ({ tier, isActive, currentUsage, disabled, onUpgrade }) => {
  const calculatePercentage = (current, limit) => {
    if (limit === 0) return 0;
    return Math.min((current / limit) * 100, 100);
  };

  const formatCost = (cost) => {
    return `$${cost.toFixed(2)}`;
  };

  return (
    <div className={`tier-card ${isActive ? 'active' : ''} ${disabled ? 'disabled' : ''}`}>
      <div className="tier-header">
        <h3 className="tier-name">{tier.name}</h3>
        <p className="tier-price">{tier.price}</p>
        {tier.comingSoon && <span className="coming-soon-badge">Coming Soon</span>}
      </div>

      <p className="tier-description">{tier.description}</p>

      <div className="tier-quotas">
        {/* Token Cost Quota */}
        <div className="quota-item">
          <div className="quota-label">
            <span>Token Cost</span>
            <span className="quota-value">
              {formatCost(currentUsage?.cost || 0)} / {formatCost(tier.costLimit)}
            </span>
          </div>
          <div className="quota-progress-bar">
            <div
              className="quota-progress-fill"
              style={{ width: `${calculatePercentage(currentUsage?.cost || 0, tier.costLimit)}%` }}
            />
          </div>
        </div>

        {/* Video Generation Quota */}
        <div className="quota-item">
          <div className="quota-label">
            <span>Videos</span>
            <span className="quota-value">
              {currentUsage?.videos || 0} / {tier.videoGenLimit}
            </span>
          </div>
          <div className="quota-progress-bar">
            <div
              className="quota-progress-fill"
              style={{ width: `${calculatePercentage(currentUsage?.videos || 0, tier.videoGenLimit)}%` }}
            />
          </div>
        </div>

        {/* Image Generation Quota */}
        <div className="quota-item">
          <div className="quota-label">
            <span>Images</span>
            <span className="quota-value">
              {currentUsage?.images || 0} / {tier.imageGenLimit}
            </span>
          </div>
          <div className="quota-progress-bar">
            <div
              className="quota-progress-fill"
              style={{ width: `${calculatePercentage(currentUsage?.images || 0, tier.imageGenLimit)}%` }}
            />
          </div>
        </div>
      </div>

      <div className="tier-footer">
        {isActive ? (
          <div className="current-tier-badge">Current Tier</div>
        ) : disabled ? (
          <button className="tier-button" disabled>
            Coming Soon
          </button>
        ) : (
          <button className="tier-button" onClick={onUpgrade}>
            Upgrade
          </button>
        )}
      </div>
    </div>
  );
};

export default TierCard;
